import { Button } from '@mui/material';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getSliderByIdFn, patchSliderFn, postSliderFn } from 'Services/Slider';
import CustomInput from 'Shared/CustomInput';
import ImageInput from 'Shared/ImageInput';
import RichTextEditor from 'Shared/RichTextEditory';

const AddUpdateSlider = () => {
    const navigate = useNavigate();
    const { id, status } = useParams();

    const { data: getSliderByIdResponse } = useQuery({
        queryKey: ['get-slider-by-id', id, status],
        queryFn: () => getSliderByIdFn(id),
        enabled: !!id && status === "update"
    })
    const data = getSliderByIdResponse?.data?.data;

    const { mutate: post } = useMutation(postSliderFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/slider')
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    })

    const { mutate: patch } = useMutation(patchSliderFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/slider')
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    })

    const initialValues = {
        image: "",
        description: data?.description || "",
        link: data?.link || ""
    }

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append('description', values.description);
            formData.append('link', values.link);

            if (status === 'add') {
                if (!values.image) return toast.error('Image is required.')
                formData.append("image", values.image);
                post(formData);
            } else {
                if (values.image) formData.append("image", values.image)
                formData.append("slider_id", id);
                patch(formData);
            }
        }
    });

    return (
        <div>
            <form
                className="bg-white shadow-md rounded-lg mx-auto p-4 flex flex-col gap-6"
                onSubmit={formik.handleSubmit}
            >
                <p className="text-xl !text-black font font-bold text-center">
                    {status === "update" ? "Update" : "Add"} Slider
                </p>
                <CustomInput formik={formik} label={"Link"} name={"link"} />
                <ImageInput formik={formik} label={"Image"} name={'image'} />
                <RichTextEditor formik={formik} label={"description"} name={"description"} />
                <Button
                    type='submit'
                    variant='contained'
                >
                    {status === "update" ? "Update" : "Add"}
                </Button>
            </form>
        </div>
    )
}

export default AddUpdateSlider;